import { render, staticRenderFns } from "./Notfind.vue?vue&type=template&id=6ab04156&scoped=true&"
import script from "./Notfind.vue?vue&type=script&lang=js&"
export * from "./Notfind.vue?vue&type=script&lang=js&"
import style0 from "./Notfind.vue?vue&type=style&index=0&id=6ab04156&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ab04156",
  null
  
)

export default component.exports